import { Injectable } from '@angular/core';
import { iBisAuthService } from '@dohu/ibis-auth';
import { iBisServerConfig } from '@dohu/ibis-common';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoopNotifyService {

  selected = new Subject<string>();
  badge = new Subject<number>();
  dataNew: any;
  dataAll: any;

  private _updated = new Subject<string>();

  constructor(private auth: iBisAuthService, private entity: iBisEntityService, private config: iBisServerConfig) {
    if (this.auth.isAuth) {
      this.refreshNotify();
    }
    this.auth.onAuthFinished.subscribe(() => this.refreshNotify());
  }

  get updated(): Subject<string> {
    return this._updated;
  }

  refreshNotify() {
    const q = new EntityQuery('NotifyAssigneeView').eq('na.userId', this.auth.user.id).
      eq('n.appId', this.auth.companyId).eq('na.seen', false).addOrderByDesc(['n.created']);
    this.dataNew = this.entity.store(q, false, 'na_id', this.config.saasServer);
    this.dataNew.totalCount({}).then((cnt: number) => {
      this.badge.next(cnt);
    });

    const qAll = q.clone();
    qAll.conditionGroups.conditions.pop();
    this.dataAll = this.entity.store(qAll, false, 'na_id', this.config.saasServer);
  }

  onSeen(ev: any) {
    this.entity.save('NotifyAssignee', ev.itemData.na_id, { seen: true }, this.config.saasServer).then(() => {
      this.refreshNotify();
    });
    this.selected.next(ev.itemData.n_entityId);
  }

}
